import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

//import '../assets/scss/index.scss';

import ko from 'vuetify/lib/locale/ko'

Vue.use(Vuetify);
Vuetify.config.silent = true;

const MY_ICONS = {
    homecare: 'wheelchair_pickup',
    homebath: 'bathtub',
    complete: 'done',
    cancel: 'close',
    close: 'close',
    delete: 'close', // delete (e.g. v-chip close)
    clear: 'close',
    success: 'mdi-checkbox-marked-circle',
    info: 'info',
    warning: 'warning',
    error: 'error',
    prev: 'keyboard_arrow_left',
    next: 'keyboard_arrow_right',
    checkboxOn: 'check_box',
    checkboxOff: 'check_box_outline_blank',
    checkboxIndeterminate: 'indeterminate_check_box',
    delimiter: 'fiber_manual_record', // for carousel
    sort: 'swap_vert',
    expand: 'expand_more',
    menu: 'menu',
    subgroup: 'keyboard_arrow_down',
    dropdown: 'arrow_drop_down',
    radioOn: 'radio_button_checked',
    radioOff: 'radio_button_unchecked',
    edit: 'edit',
    ratingEmpty: 'mdi-star-outline',
    ratingFull: 'mdi-star',
    ratingHalf: 'mdi-star-half-full',
    // loading: '...',
    // first: '...',
    // last: '...',
    // unfold: '...',
    file: 'attach_file',
}

const opts = {
    icons: {
        iconfont: 'mdi | mdiSvg | md',
        values: MY_ICONS
    },
    lang: {
        locales: { ko },
        current: 'ko',
    },
    theme: {
        dark: false,
        light: {
            primary: '#4a72fe', // '#3f51b5',
            secondary: '#3f51b5', // '#b0bec5',
            accent: '#fd397a', // '#8c9eff',
            error: '#cf001c', // '#FF5252',
            info: '#00c3d0', // '#2196F3',
            success: '#0abb87', // '#4CAF50',
            warning: '#ff9110', // '#FFC107',
            anchor: '#8c9eff',
            red: '#cf001c', // not default for vuetify
            mint: '#00c3d0', // not default for vuetify
            pink: '#fd397a', // not default for vuetify
            orange: '#ff9110', // not default for vuetify
            blue: '#4a72fe', // not default for vuetify
            green: '#0abb87', // not default for vuetify
            violet: '#7d6af3', // not default for vuetify
        }
    }
};

export default new Vuetify(opts);


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js